// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import BankAccount from "./bank-account.js"
import Contact from "./contact.js"
import FinanceAccount from "./finance-account.js"
import FinanceDimensionValue from "./finance-dimension-value.js"
import Log from "./log.js"
import ReimbursementAttachment from "./reimbursement-attachment.js"

const modelClassData = {
  "attributes": {
    "bank_account_id": {
      "column": {
        "default": null,
        "name": "bank_account_id",
        "null": true,
        "type": "uuid"
      },
      "name": "bank_account_id",
      "selected_by_default": null,
      "translated": null
    },
    "bearer_id": {
      "column": {
        "default": null,
        "name": "bearer_id",
        "null": true,
        "type": "uuid"
      },
      "name": "bearer_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "creator_id": {
      "column": {
        "default": null,
        "name": "creator_id",
        "null": true,
        "type": "uuid"
      },
      "name": "creator_id",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "distance": {
      "column": {
        "default": null,
        "name": "distance",
        "null": true,
        "type": "float"
      },
      "name": "distance",
      "selected_by_default": null,
      "translated": null
    },
    "expense_amount": {
      "column": null,
      "name": "expense_amount",
      "selected_by_default": null,
      "translated": null
    },
    "expense_amount_cents": {
      "column": {
        "default": null,
        "name": "expense_amount_cents",
        "null": true,
        "type": "integer"
      },
      "name": "expense_amount_cents",
      "selected_by_default": null,
      "translated": null
    },
    "expense_date": {
      "column": {
        "default": null,
        "name": "expense_date",
        "null": true,
        "type": "date"
      },
      "name": "expense_date",
      "selected_by_default": null,
      "translated": null
    },
    "gratisal": {
      "column": {
        "default": false,
        "name": "gratisal",
        "null": false,
        "type": "boolean"
      },
      "name": "gratisal",
      "selected_by_default": null,
      "translated": null
    },
    "hours": {
      "column": {
        "default": null,
        "name": "hours",
        "null": true,
        "type": "float"
      },
      "name": "hours",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "number": {
      "column": {
        "default": null,
        "name": "number",
        "null": false,
        "type": "integer"
      },
      "name": "number",
      "selected_by_default": null,
      "translated": null
    },
    "purpose_id": {
      "column": {
        "default": null,
        "name": "purpose_id",
        "null": true,
        "type": "uuid"
      },
      "name": "purpose_id",
      "selected_by_default": null,
      "translated": null
    },
    "quantity": {
      "column": null,
      "name": "quantity",
      "selected_by_default": null,
      "translated": null
    },
    "reimbursement_amount": {
      "column": null,
      "name": "reimbursement_amount",
      "selected_by_default": null,
      "translated": null
    },
    "reimbursement_rate": {
      "column": null,
      "name": "reimbursement_rate",
      "selected_by_default": null,
      "translated": null
    },
    "reimbursement_rate_cents": {
      "column": {
        "default": null,
        "name": "reimbursement_rate_cents",
        "null": true,
        "type": "integer"
      },
      "name": "reimbursement_rate_cents",
      "selected_by_default": null,
      "translated": null
    },
    "reimbursement_type": {
      "column": {
        "default": null,
        "name": "reimbursement_type",
        "null": false,
        "type": "string"
      },
      "name": "reimbursement_type",
      "selected_by_default": null,
      "translated": null
    },
    "smart_bank_entry_identifier": {
      "column": {
        "default": null,
        "name": "smart_bank_entry_identifier",
        "null": true,
        "type": "string"
      },
      "name": "smart_bank_entry_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_reimbursement_type": {
      "column": null,
      "name": "translated_reimbursement_type",
      "selected_by_default": null,
      "translated": null
    },
    "travel_from": {
      "column": {
        "default": null,
        "name": "travel_from",
        "null": true,
        "type": "string"
      },
      "name": "travel_from",
      "selected_by_default": null,
      "translated": null
    },
    "travel_to": {
      "column": {
        "default": null,
        "name": "travel_to",
        "null": true,
        "type": "string"
      },
      "name": "travel_to",
      "selected_by_default": null,
      "translated": null
    },
    "travel_via": {
      "column": {
        "default": null,
        "name": "travel_via",
        "null": true,
        "type": "string"
      },
      "name": "travel_via",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "bookable": {
      "column": null,
      "name": "bookable",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Reimbursement",
  "collectionKey": "reimbursements",
  "collectionName": "reimbursements",
  "i18nKey": "reimbursement",
  "camelizedLower": "reimbursement",
  "name": "Reimbursement",
  "nameDasherized": "reimbursement",
  "pluralName": "reimbursements",
  "ransackable_associations": [
    {
      "className": "ReimbursementAttachment",
      "collectionName": "reimbursement_attachments",
      "foreignKey": "reimbursement_id",
      "name": "attachments",
      "macro": "has_many",
      "resource_name": "ReimbursementAttachment",
      "through": null
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "bank_account_id",
      "name": "bank_account",
      "macro": "belongs_to",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "bearer_id",
      "name": "bearer",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Comment",
      "collectionName": "comments",
      "foreignKey": "commentable_id",
      "name": "comments",
      "macro": "has_many",
      "resource_name": "Comment",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "creator_id",
      "name": "creator",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "latest_update_log",
      "macro": "has_one",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "purpose_id",
      "name": "purpose",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "bank_account_id",
      "column": {
        "default": null,
        "name": "bank_account_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "bearer_id",
      "column": {
        "default": null,
        "name": "bearer_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "creator_id",
      "column": {
        "default": null,
        "name": "creator_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "distance",
      "column": {
        "default": null,
        "name": "distance",
        "null": true,
        "type": "float"
      }
    },
    {
      "name": "expense_amount_cents",
      "column": {
        "default": null,
        "name": "expense_amount_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "expense_amount_currency",
      "column": {
        "default": "DKK",
        "name": "expense_amount_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "expense_date",
      "column": {
        "default": null,
        "name": "expense_date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "finance_account_id",
      "column": {
        "default": null,
        "name": "finance_account_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "gratisal",
      "column": {
        "default": false,
        "name": "gratisal",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "hours",
      "column": {
        "default": null,
        "name": "hours",
        "null": true,
        "type": "float"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "number",
      "column": {
        "default": null,
        "name": "number",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "old_bank_account_id",
      "column": {
        "default": null,
        "name": "old_bank_account_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_bearer_id",
      "column": {
        "default": null,
        "name": "old_bearer_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_creator_id",
      "column": {
        "default": null,
        "name": "old_creator_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_finance_account_id",
      "column": {
        "default": null,
        "name": "old_finance_account_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_purpose_id",
      "column": {
        "default": null,
        "name": "old_purpose_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "purpose_id",
      "column": {
        "default": null,
        "name": "purpose_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "reimbursement_amount_cents",
      "column": {
        "default": null,
        "name": "reimbursement_amount_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "reimbursement_amount_currency",
      "column": {
        "default": "DKK",
        "name": "reimbursement_amount_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "reimbursement_rate_cents",
      "column": {
        "default": null,
        "name": "reimbursement_rate_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "reimbursement_rate_currency",
      "column": {
        "default": null,
        "name": "reimbursement_rate_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "reimbursement_type",
      "column": {
        "default": null,
        "name": "reimbursement_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "smart_bank_entry_identifier",
      "column": {
        "default": null,
        "name": "smart_bank_entry_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "travel_from",
      "column": {
        "default": null,
        "name": "travel_from",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "travel_to",
      "column": {
        "default": null,
        "name": "travel_to",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "travel_via",
      "column": {
        "default": null,
        "name": "travel_via",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_attachments_present_asc"
    },
    {
      "name": "sort_by_attachments_present_desc"
    },
    {
      "name": "sort_by_contact_name_asc"
    },
    {
      "name": "sort_by_contact_name_desc"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    },
    {
      "name": "where_not_user"
    }
  ],
  "relationships": [
    {
      "className": "ReimbursementAttachment",
      "collectionName": "reimbursement_attachments",
      "foreignKey": "reimbursement_id",
      "name": "attachments",
      "macro": "has_many",
      "resource_name": "ReimbursementAttachment",
      "through": null
    },
    {
      "className": "BankAccount",
      "collectionName": "bank_accounts",
      "foreignKey": "bank_account_id",
      "name": "bank_account",
      "macro": "belongs_to",
      "resource_name": "BankAccount",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "bearer_id",
      "name": "bearer",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "latest_update_log",
      "macro": "has_one",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "purpose_id",
      "name": "purpose",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    }
  ],
  "paramKey": "reimbursement",
  "primaryKey": "id"
}

/** Frontend model for Reimbursement. */
export default class Reimbursement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  bankAccountId() {
    return this.readAttributeUnderscore("bank_account_id")
  }

  /** @returns {boolean} */
  hasBankAccountId() {
    const value = this.bankAccountId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  bearerId() {
    return this.readAttributeUnderscore("bearer_id")
  }

  /** @returns {boolean} */
  hasBearerId() {
    const value = this.bearerId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  creatorId() {
    return this.readAttributeUnderscore("creator_id")
  }

  /** @returns {boolean} */
  hasCreatorId() {
    const value = this.creatorId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  distance() {
    return this.readAttributeUnderscore("distance")
  }

  /** @returns {boolean} */
  hasDistance() {
    const value = this.distance()

    return this._isPresent(value)
  }

  /** @returns {any} */
  expenseAmount() {
    return this.readAttributeUnderscore("expense_amount")
  }

  /** @returns {boolean} */
  hasExpenseAmount() {
    const value = this.expenseAmount()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  expenseAmountCents() {
    return this.readAttributeUnderscore("expense_amount_cents")
  }

  /** @returns {boolean} */
  hasExpenseAmountCents() {
    const value = this.expenseAmountCents()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  expenseDate() {
    return this.readAttributeUnderscore("expense_date")
  }

  /** @returns {boolean} */
  hasExpenseDate() {
    const value = this.expenseDate()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  gratisal() {
    return this.readAttributeUnderscore("gratisal")
  }

  /** @returns {boolean} */
  hasGratisal() {
    const value = this.gratisal()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  hours() {
    return this.readAttributeUnderscore("hours")
  }

  /** @returns {boolean} */
  hasHours() {
    const value = this.hours()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  number() {
    return this.readAttributeUnderscore("number")
  }

  /** @returns {boolean} */
  hasNumber() {
    const value = this.number()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  purposeId() {
    return this.readAttributeUnderscore("purpose_id")
  }

  /** @returns {boolean} */
  hasPurposeId() {
    const value = this.purposeId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  quantity() {
    return this.readAttributeUnderscore("quantity")
  }

  /** @returns {boolean} */
  hasQuantity() {
    const value = this.quantity()

    return this._isPresent(value)
  }

  /** @returns {any} */
  reimbursementAmount() {
    return this.readAttributeUnderscore("reimbursement_amount")
  }

  /** @returns {boolean} */
  hasReimbursementAmount() {
    const value = this.reimbursementAmount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  reimbursementRate() {
    return this.readAttributeUnderscore("reimbursement_rate")
  }

  /** @returns {boolean} */
  hasReimbursementRate() {
    const value = this.reimbursementRate()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  reimbursementRateCents() {
    return this.readAttributeUnderscore("reimbursement_rate_cents")
  }

  /** @returns {boolean} */
  hasReimbursementRateCents() {
    const value = this.reimbursementRateCents()

    return this._isPresent(value)
  }

  /** @returns {string} */
  reimbursementType() {
    return this.readAttributeUnderscore("reimbursement_type")
  }

  /** @returns {boolean} */
  hasReimbursementType() {
    const value = this.reimbursementType()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  smartBankEntryIdentifier() {
    return this.readAttributeUnderscore("smart_bank_entry_identifier")
  }

  /** @returns {boolean} */
  hasSmartBankEntryIdentifier() {
    const value = this.smartBankEntryIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedReimbursementType() {
    return this.readAttributeUnderscore("translated_reimbursement_type")
  }

  /** @returns {boolean} */
  hasTranslatedReimbursementType() {
    const value = this.translatedReimbursementType()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  travelFrom() {
    return this.readAttributeUnderscore("travel_from")
  }

  /** @returns {boolean} */
  hasTravelFrom() {
    const value = this.travelFrom()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  travelTo() {
    return this.readAttributeUnderscore("travel_to")
  }

  /** @returns {boolean} */
  hasTravelTo() {
    const value = this.travelTo()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  travelVia() {
    return this.readAttributeUnderscore("travel_via")
  }

  /** @returns {boolean} */
  hasTravelVia() {
    const value = this.travelVia()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  bookable() {
    return this.readAttributeUnderscore("bookable")
  }

  /** @returns {boolean} */
  hasBookable() {
    const value = this.bookable()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static bookAllInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "book_all_in_business_central",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static expenseSum(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "expense_sum",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static syncSmartBankAccountEntries(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "sync_smart_bank_account_entries",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static timeSum(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "time_sum",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static travelSum(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "travel_sum",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceClose(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_close",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceCreateInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_create_in_business_central",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceProcessedInGratisal(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_processed_in_gratisal",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceReject(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_reject",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceSyncBookedStateWithBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_sync_booked_state_with_business_central",
        collectionName: "reimbursements",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createInBusinessCentral(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_in_business_central",
        primaryKey: this.primaryKey(),
        collectionName: "reimbursements",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./reimbursement-attachment.js").default>} */
  attachments() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["reimbursement_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "attachments",
        model: this,
        modelClass: ReimbursementAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./reimbursement-attachment.js").default>>} */
  loadAttachments() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["reimbursement_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "attachments",
        model: this,
        modelClass: ReimbursementAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./reimbursement-attachment.js").default>>} */
  ensureAttachmentsLoaded() {
    return this.ensureAssociationLoaded("attachments")
  }

  /** @returns {import("./bank-account.js").default | null} */
  bankAccount() {
    return this._readBelongsToReflection({modelClass: BankAccount, reflectionName: "bank_account"})
  }

  /** @returns {Promise<import("./bank-account.js").default | null>} */
  loadBankAccount() {
    if (!("bankAccountId" in this)) throw new Error("Foreign key method wasn't defined: bankAccountId")

    const id = this.bankAccountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bank_account",
        model: this,
        modelClass: BankAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./bank-account.js").default | null>} */
  ensureBankAccountLoaded() {
    return this.ensureAssociationLoaded("bank_account")
  }

  /** @returns {import("./finance-dimension-value.js").default | null} */
  bearer() {
    return this._readBelongsToReflection({modelClass: FinanceDimensionValue, reflectionName: "bearer"})
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  loadBearer() {
    if (!("bearerId" in this)) throw new Error("Foreign key method wasn't defined: bearerId")

    const id = this.bearerId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "bearer",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  ensureBearerLoaded() {
    return this.ensureAssociationLoaded("bearer")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./finance-account.js").default | null} */
  financeAccount() {
    return this._readBelongsToReflection({modelClass: FinanceAccount, reflectionName: "finance_account"})
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  loadFinanceAccount() {
    if (!("financeAccountId" in this)) throw new Error("Foreign key method wasn't defined: financeAccountId")

    const id = this.financeAccountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_account",
        model: this,
        modelClass: FinanceAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  ensureFinanceAccountLoaded() {
    return this.ensureAssociationLoaded("finance_account")
  }

  /** @returns {import("./log.js").default | null} */
  latestUpdateLog() {
    return this._readHasOneReflection({modelClass: Log, reflectionName: "latest_update_log"})
  }

  /** @returns {Promise<import("./log.js").default | null>} */
  loadLatestUpdateLog() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["trackable_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "latest_update_log",
        model: this,
        modelClass: Log
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./log.js").default | null>} */
  ensureLatestUpdateLogLoaded() {
    return this.ensureAssociationLoaded("latest_update_log")
  }

  /** @returns {import("./finance-dimension-value.js").default | null} */
  purpose() {
    return this._readBelongsToReflection({modelClass: FinanceDimensionValue, reflectionName: "purpose"})
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  loadPurpose() {
    if (!("purposeId" in this)) throw new Error("Foreign key method wasn't defined: purposeId")

    const id = this.purposeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "purpose",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  ensurePurposeLoaded() {
    return this.ensureAssociationLoaded("purpose")
  }
}
